import { useEffect } from "react";
import { UserRole, WorkStatus } from "tm-shared/types";

import {
    useAppDispatch,
    useAppSelector,
    useOfflineModeSelector,
    useProtectedUserRoleSelector,
} from "@/hooks/redux";
import { getCheckoutsThunk } from "@/store/slices/ui";

export const useTaCheckoutPrefetchEffect = () => {
    const route = useAppSelector((s) => s.user.route);
    const role = useProtectedUserRoleSelector();
    const offlineMode = useOfflineModeSelector();
    const workStatus = useAppSelector((s) => s.work.workStatus);

    const routeId = route?.uuid;

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (
            role !== UserRole.Ta ||
            !routeId ||
            workStatus !== WorkStatus.StartWork ||
            offlineMode
        ) {
            return;
        }

        dispatch(getCheckoutsThunk({ routeId }));
    }, [dispatch, offlineMode, role, routeId, workStatus]);
};
